import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    is_no_records: '',
    lists: {},
    total_count: '',
    count: 1,
    list: {},
    filter_list: {},
    filter_name: '',
    Updatelist: {},
    search_criteria: '',
    message: {},
    inventory_accounts: [],
    acc_types: [],
    unit_list: [],
    delete: {},
    exempt_reason_list: [],
    error: '',
    details: '',
    log_details: '',
    igst_tax: [],
    local_tax: [],
    sales_account: [],
    purchase_account: [],
    producttaglist: [],
    export: {},
    status_code: '',
    status_message: '',
    status_type: '',

    bundle_index_history: '',
    index_status: ''

}
const mutations = {
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },

    SET_DATAS(state, lists) {
        state.error = ''
        state.lists = lists.product_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.is_no_records = lists.is_no_records
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    LIST_VIEW_DATA(state, list) {
        state.listView = list
        state.invoice_list = {}
        state.quotation_list = {}
        state.credit_list = {}
        state.total_invoice_list = ""
        state.total_quotation_list = ""
        state.total_credit_list = ""
    },
    LIST_DATA(state, data) {
        state.list = data
        state.error = ''
    },
    LIST_DETAILS(state, data) {
        state.igst_tax = data.igst_tax,
            state.unit_list = data.unit_list,
            state.local_tax = data.local_tax,
            state.producttaglist = data.producttaglist,
            state.sales_account = data.sales_account,
            state.purchase_account = data.purchase_accounts,
            state.inventory_accounts = data.inventory_accounts
        state.exempt_reason_list = data.exempt_reason_list,
            state.acc_types = data.acc_types
    },

    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    DELETE_DROPDOWN(state, data) {

        state.code = data.status
        state.message = data.data.status
    },

    DELETE_RESULT(state, delete_result) {
        state.delete = delete_result
    }
}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {

        return AppService.amcservice.getAmcServices(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                } else {
                    commit("SET_CODE", response.data);
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    singlestatus({
        commit,
        rootState
    }, data) {

        return AppService.amcservice.postsinglestatus(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },


    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {

        return AppService.amcservice.getAmcExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcompositedetails({
        commit,
        rootState
    }) {
        return AppService.amcservice.getcompositedetails(rootState.session.token)
            .then(response => {
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchViewList({
        commit,
        rootState
    }, id) {

        return AppService.amcservice.getProductBundleView(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_VIEW_DATA', response.data.data)
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.amcservice.postAmcService(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    //  delete product 
    deleteproduct({
        commit,
        rootState
    }, data) {

        return AppService.amcservice.getProductDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {
        return AppService.amcservice.postAmcServiceUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    pdtstatus({
        commit,
        rootState
    }, data) {

        return AppService.amcservice.postPdtstatus(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_LOG', response.data);
                    commit('STATUS_CODE', response.status)
                    commit('DELETE_RESULT', response.data.status)
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    pdtdelete({
        commit,
        rootState
    }, id) {

        return AppService.amcservice.postpdtdelete(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status)
                    commit('DELETE_RESULT', response.data.status) // getting all the list in the api call
                    commit('LIST_LOG', response.data)
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchAmcServiceList({
        commit,
        rootState
    },{id,type}) {

        return AppService.amcservice.getAmcService(id,type, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
}
export default {
    namespaced,
    state,
    mutations,
    actions
}